import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledListFolder = styled.div`
  align-items: center;
  background: ${colors.white};
  column-gap: ${spacing.base};
  display: grid;
  grid-template-columns: ${pxToRem(48)} ${spacing.base} 1fr auto;
  justify-content: start;
  padding: ${spacing.half} ${spacing.layoutLRPadding};

  &:nth-child(even) {
    background: ${colors.grey1};
  }
`;

type Props = {
  id: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};
export const FolderRow: FunctionComponent<React.PropsWithChildren<Props>> = ({
  children,
  id,
  onMouseEnter,
  onMouseLeave,
}) => (
  <StyledListFolder
    data-test={`folder-row-${id}`}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    {children}
  </StyledListFolder>
);
